import { StateCreator } from 'zustand';
import {
  AdminStore,
  CCPUserDetails,
  CompanyList,
  MemberFileList,
  SelectedCompany
} from '@interfaces/admin-store';

const initialState = {
  companyList: [],
  selectedCompany: {
    cce: '',
    state: ''
  },
  companyDetails: {
    ccpUserDetails: [],
    memberFileList: []
  }
};

export const AdminSlice: StateCreator<AdminStore> = (set) => ({
  ...initialState,
  updateCompanyList: (companyList: CompanyList[]) =>
    set({ companyList: companyList }),
  updateSelectedCompany: (selectedCompany: SelectedCompany) =>
    set({ selectedCompany: selectedCompany }),
  updateccpUserDetails: (ccpUserDetails: CCPUserDetails[]) => {
    set((state) => {
      return {
        companyDetails: {
          ...state.companyDetails,
          ccpUserDetails: ccpUserDetails
        }
      };
    });
  },
  updateMemberFileList: (memberFileList: MemberFileList[]) => {
    set((state) => {
      return {
        companyDetails: {
          ...state.companyDetails,
          memberFileList: memberFileList
        }
      };
    });
  },
  updateCCPUserDetailById: (
    userId: string,
    updatedDetails: Partial<CCPUserDetails>
  ) => {
    set((state) => {
      const ccpUserDetails = state.companyDetails.ccpUserDetails;
      if (!ccpUserDetails) return state;
      const index = ccpUserDetails?.findIndex((user) => user.userId === userId);
      ccpUserDetails[index] = { ...ccpUserDetails[index], ...updatedDetails };
      return {
        companyDetails: {
          ...state.companyDetails,
          ccpUserDetails: ccpUserDetails
        }
      };
    });
  },

  resetAdminStore: () => set(initialState)
});
